export const WEAK_PASSWORD_REMINDER_STORAGE_KEY = 'weak-password-reminder';

export const DEFAULT_WEAK_PASSWORD_TIP = '当前密码安全强度较低，请尽快修改密码';

export function saveWeakPasswordReminder(passwordTip) {
    window.sessionStorage.setItem(
        WEAK_PASSWORD_REMINDER_STORAGE_KEY,
        JSON.stringify({passwordTip: passwordTip || DEFAULT_WEAK_PASSWORD_TIP})
    );
}

export function clearWeakPasswordReminder() {
    window.sessionStorage.removeItem(WEAK_PASSWORD_REMINDER_STORAGE_KEY);
}

/**
 * 消费一次登录后的提醒，读取后立即删除，避免刷新页面重复弹出。
 */
export function consumeWeakPasswordReminder() {
    const reminder = window.sessionStorage.getItem(WEAK_PASSWORD_REMINDER_STORAGE_KEY);
    clearWeakPasswordReminder();

    if (!reminder) return null;

    try {
        const {passwordTip} = JSON.parse(reminder);
        return {passwordTip: passwordTip || DEFAULT_WEAK_PASSWORD_TIP};
    } catch (error) {
        return null;
    }
}
